import { AES, enc } from 'crypto-js';

const secretSalt = process.env.REACT_APP_SLICE_SALT

export const encryptObjectData = ({ objectData }) => {

    const stringifiedObj = JSON.stringify(objectData) || ""
    const ciphertext = AES.encrypt(stringifiedObj, secretSalt)

    const encryptedObjectData = ciphertext.toString();

    return encryptedObjectData
}

export const decryptObjectData = ({ encyptedObjectData }) => {

    const bytes = AES.decrypt(encyptedObjectData, secretSalt);
    const decryptedObjectData = JSON.parse(bytes.toString(enc.Utf8));

    return decryptedObjectData

}